import { ListItem, StyledComponentProps, Divider } from '@material-ui/core';
import * as React from 'react';
import { subscription } from '../../../model/subscription';
import { SubscriptionInfo } from './SubscriptionInfo';

interface IProps extends StyledComponentProps {
    // doneReminder: (reminder: reminder, done: boolean) => void;
    onSubscriptionClick: (_id: string) => void;
    subscription: subscription;
    isSelected: boolean;
    // showContactInfo?: boolean;
    // navigateTo: (path: string) => void;
}
interface IState {
    // open: boolean;
    // reminder: reminder;
    // openRoom: boolean;
}


export class SubscriptionItem extends React.Component<IProps, IState> {
    // state = { open: false } //, reminder: this.props.reminder }

    setSelected = (_done: boolean) => {
        // this.props.doneReminder(this.props.subscription, _done);
        // console.log("REMINDERRRRRRRRRRRRRRRRRRR SET SELECTED :" + _done); // JSON.stringify(this.state.reminder));
    }

    // private expandTags = (evt: React.MouseEvent<SVGSVGElement, MouseEvent>, open: boolean, openRoom: boolean) => {
    //     this.setState({
    //         open: open,
    //         // openRoom: open
    //     });
    //     evt.stopPropagation();
    // }

    render() {
        const { subscription, classes } = this.props;
        return (
            <>
                <ListItem button
                        onClick={() => this.props.onSubscriptionClick(this.props.subscription._id)}
                        className={this.props.isSelected ? classes.selectedSubscription : classes.subscription} >               
                    <SubscriptionInfo 
                        subscription={subscription} 
                        // showContactInfo={this.props.showContactInfo ?? true}
                        // setSelected={this.setSelected} 
                        classes={classes} />
                        
                </ListItem>
                <Divider />
            </>
        );
    }
}